import AppHeader from "../../layout/AppHeader";
import AuditList from '../../xpost/views/dashboard/prepost/AuditList.vue';
import Services from '../../xpost/views/register/services/Services.vue';
import ServicesAdd from '../../xpost/views/register/services/ServicesAdd.vue';
import AuditFileList from '../../xpost/views/services/audit/AuditFileList.vue';
import BilletExcelFileList from '../../xpost/views/dashboard/billet.excel/BilletExcelFileList.vue';

const ServicesRoutes = [
    {
        path: "/cadastro/servico",
        name: "services",
        components: {
            header: AppHeader,
            default: Services
        }
    },
    {
        path: "/cadastro/servico/adicionar",
        name: "services.add",
        components: {
            header: AppHeader,
            default: ServicesAdd
        }
    },
    {
        path: '/cadastro/servico/adicionar/:id',
        name: 'services.edit',
        components: {
            header: AppHeader,
            default: ServicesAdd
        }
    },
    {
        path: '/servicos/auditoria',
        name: 'services.audit',
        components: {
            header: AppHeader,
            default: AuditList
        }
    },
    {
        path: '/servicos/auditoria/arquivos',
        name: 'services.file.audit',
        components: {
            header: AppHeader,
            default: AuditFileList
        }
    },
    {
        path: '/servicos/planilha/arquivos',
        name: 'services.file.billet',
        components: {
            header: AppHeader,
            default: BilletExcelFileList
        }
    }
]

export default ServicesRoutes;